<div class="message-thread">
    <!-- Thread Header -->
    <div class="thread-header" *ngIf="thread as t" [class.d-none]="hideHeader">
        <div class="header-name">{{ t.customerName }}</div>
        <div class="header-booking-details" *ngIf="booking">
            <span class="booking-chip">
                {{ booking.start | date:'EEE d MMM y' }}
            </span>
            <span class="booking-chip">
                {{ booking.start | date:'HH:mm' }} &mdash; {{ booking.end | date:'HH:mm' }}
            </span>
            <span class="booking-chip">
                {{ booking.size }} {{ booking.size === 1 ? 'Person' : 'People' }}
            </span>
        </div>
        <div class="header-booking-details" *ngIf="!booking && t">
            <span class="booking-chip">
                {{ t.bookingDate | date:'EEE d MMM y' }}
            </span>
            <span class="booking-chip">
                {{ t.partySize }} {{ t.partySize === 1 ? 'Person' : 'People' }}
            </span>
        </div>

        <div class="request-actions" *ngIf="isRequestedBooking && booking">
            <div class="request-summary">
                Booking request awaiting your response
            </div>
            <div class="request-action-buttons">
                <button
                    class="btn btn-success"
                    [disabled]="requestActionLoading"
                    (click)="acceptBookingRequest()"
                >
                    Accept Booking
                </button>
                <button
                    class="btn btn-outline-danger"
                    [disabled]="requestActionLoading"
                    (click)="rejectBookingRequest()"
                >
                    Reject Booking
                </button>
            </div>
        </div>
    </div>

    <!-- Messages -->
    <div
        #messagesContainer
        class="messages-container flex-grow-1 overflow-auto"
    >
        <!-- Loading -->
        <div *ngIf="loading" class="text-center p-4">
            <div class="spinner-border spinner-border-sm text-primary" role="status"></div>
            <div class="message-loading-label text-muted mt-2">Loading messages...</div>
        </div>

        <!-- Empty -->
        <div *ngIf="!loading && messages.length === 0" class="text-center p-5 text-muted">
            <i class="bi bi-chat-dots d-block mb-2" style="font-size: 1.5rem"></i>
            <span class="empty-thread-label">No messages in this conversation yet</span>
        </div>

        <!-- Message bubbles -->
        <div class="messages-list" *ngIf="!loading && messages.length > 0">
            <div
                *ngFor="let message of messages; let i = index; trackBy: trackByMessageId"
                class="message-row"
                [class.sent]="message.isMerchant()"
                [class.received]="message.isCustomer()"
            >
                <!-- Date separator -->
                <div
                    *ngIf="shouldShowDateSeparator(i)"
                    class="date-separator"
                >
                    <span>{{ message.dateCreated | date:'EEEE, d MMMM y' }}</span>
                </div>

                <!-- Sender label -->
                <div class="sender-label" *ngIf="shouldShowSenderLabel(i)">
                    {{ message.isMerchant() ? 'You' : thread?.customerName }}
                </div>

                <div class="message-bubble">
                    <div *ngIf="message.subject" class="message-subject">
                        {{ message.subject }}
                    </div>
                    <div class="message-body" [innerText]="message.messageBody"></div>
                    <div class="message-time">
                        {{ message.dateCreated | date:'HH:mm' }}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Compose Area -->
    <div class="compose-area" *ngIf="canSendMessages">
        <div class="compose-wrapper">
            <textarea
                #composeTextarea
                class="compose-input"
                placeholder="Write a message..."
                [(ngModel)]="newMessageBody"
                (keydown)="onKeyDown($event)"
                rows="1"
                [disabled]="sendingMessage"
                (input)="autoResizeTextarea($event)"
            ></textarea>
            <button
                class="send-button btn btn-primary"
                [disabled]="!newMessageBody.trim() || sendingMessage"
                (click)="sendMessage()"
            >
                <i *ngIf="!sendingMessage" class="bi bi-send-fill"></i>
                <span
                    *ngIf="sendingMessage"
                    class="spinner-border spinner-border-sm"
                    role="status"
                ></span>
            </button>
        </div>
        <div class="compose-hint">
            Press <kbd>Enter</kbd> to send, <kbd>Shift + Enter</kbd> for new line
        </div>
    </div>
</div>
